import * as types from "./actionTypes";
import * as authApi from "../../../api/auth";

import { loadProfile, removeProfile } from "../profile/profileActions";
import { setSyncToastNotifications } from "../../../utils/storage";
import { toast } from "react-toastify";

//redux actions
export function loginSuccess(data) {
  return { type: types.LOGIN_SUCCESS, data };
}
export function _logout() {
  return { type: types.LOGOUT };
}

// //login action
export function login(payload) {
  return function (dispatch) {
    return authApi
      .signinApi(payload)
      .then((result) => {
        const data = result.data;

        localStorage.setItem("logged", true);
        dispatch(loginSuccess(data));

        dispatch(loadProfile(data.userInfo));

        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function googleSignIn(payload) {
  return function (dispatch) {
    return authApi
      .googleSignInApi(payload)
      .then((result) => {
        const data = result.data;

        localStorage.setItem("logged", true);
        dispatch(loginSuccess(data));

        dispatch(loadProfile(data.userInfo));

        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function logout(payload) {
  return function (dispatch) {
    return authApi
      .signoutApi(payload)
      .then((result) => {
        localStorage.removeItem("logged");

        dispatch(removeProfile());
        dispatch(_logout());

        if (window.location.pathname.includes("dashboard")) {
          const notification = {
            type: "SUCCESS",
            message: result.message,
          };

          setSyncToastNotifications([notification]);

          window.location.replace("/");
        } else {
          toast.success(result.message);
        }
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function removeAuth({ message = "You have been logged out. Please login again." }) {
  return function (dispatch) {
    localStorage.removeItem("logged");

    dispatch(removeProfile());
    dispatch(_logout());

    if (window.location.pathname.includes("dashboard")) {
      const notification = {
        type: "INFO",
        message: message,
      };

      setSyncToastNotifications([notification]);

      window.location.replace("/");
    } else {
      toast.info(message);
    }
  };
}
